export class ClinicModel {
    clinic_no: number;
    clinic_abbrev: string;
    clinic_name: string;
    clinic_type: number;
    clinic_store_no: string;
    clinic_code: string;
    clinic_address: string;
    clinic_zip: string;
    clinic_zip_ext: string;
    clinic_phone: string;
    clinic_fax: string;
    clinic_email: string;
    tax_rate1: number;
    tax_rate2: number;
    tax_rate3: number;
    invoice_message: string;
    rab_proc: number;
    health_proc: number;
    neu_proc: number;
    pet_info_proc: number;
    city_lic_no: number;
    rabie_lic_city: string;
    lab_result_flag: boolean;
    ask_tax: boolean;
    clinic_doctor: number;
    doctor_date: string;
    admin_password: string;
    corp_password: string;
    manage_password: string;
    inv_proc_password: string;
    clinic_active: boolean;
    tenant_no: number;
    web_phone: string;
    country_code: string;

    constructor(
        clinic_no: number,
        clinic_abbrev: string,
        clinic_name: string,
        clinic_type: number,
        clinic_store_no: string,
        clinic_code: string,
        clinic_address: string,
        clinic_zip: string,
        clinic_zip_ext: string,
        clinic_phone: string,
        clinic_fax: string,
        clinic_email: string,
        tax_rate1: number,
        tax_rate2: number,
        tax_rate3: number,
        invoice_message: string,
        rab_proc: number,
        health_proc: number,
        neu_proc: number,
        pet_info_proc: number,
        city_lic_no: number,
        rabie_lic_city: string,
        lab_result_flag: boolean,
        ask_tax: boolean,
        clinic_doctor: number,
        doctor_date: string,
        admin_password: string,
        corp_password: string,
        manage_password: string,
        inv_proc_password: string,
        clinic_active: boolean,
        tenant_no: number,
        web_phone: string,
        country_code: string
    ) {
        this.clinic_no = clinic_no
        this.clinic_abbrev = clinic_abbrev
        this.clinic_name = clinic_name
        this.clinic_type = clinic_type
        this.clinic_store_no = clinic_store_no
        this.clinic_code = clinic_code
        this.clinic_address = clinic_address
        this.clinic_zip = clinic_zip
        this.clinic_zip_ext = clinic_zip_ext
        this.clinic_phone = clinic_phone
        this.clinic_fax = clinic_fax
        this.clinic_email = clinic_email
        this.tax_rate1 = tax_rate1
        this.tax_rate2 = tax_rate2
        this.tax_rate3 = tax_rate3
        this.invoice_message = invoice_message
        this.rab_proc = rab_proc
        this.health_proc = health_proc
        this.neu_proc = neu_proc
        this.pet_info_proc = pet_info_proc
        this.city_lic_no = city_lic_no
        this.rabie_lic_city = rabie_lic_city
        this.lab_result_flag = lab_result_flag
        this.ask_tax = ask_tax
        this.clinic_doctor = clinic_doctor
        this.doctor_date = doctor_date
        this.admin_password = admin_password
        this.corp_password = corp_password
        this.manage_password = manage_password
        this.inv_proc_password = inv_proc_password
        this.clinic_active = clinic_active
        this.tenant_no = tenant_no
        this.web_phone = web_phone
        this.country_code = country_code
    }
}